// extracted by mini-css-extract-plugin
module.exports = {"additionalTermsButton":"PlaceBid_additionalTermsButton__3eI3O","additionalTermsText":"PlaceBid_additionalTermsText__2mGkP"};